/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Tool usage user identity kind
 */
export const ToolUsageUserTimeSeriesPointUserKind = {
  Email: "email",
  ExternalUserId: "external_user_id",
  UserId: "user_id",
  AgentId: "agent_id",
  Unknown: "unknown",
} as const;
/**
 * Tool usage user identity kind
 */
export type ToolUsageUserTimeSeriesPointUserKind = ClosedEnum<
  typeof ToolUsageUserTimeSeriesPointUserKind
>;

/**
 * A time-series bucket for one tool usage user identity
 */
export type ToolUsageUserTimeSeriesPoint = {
  /**
   * Bucket start time in Unix nanoseconds as a string for JavaScript integer safety
   */
  bucketStartNs: string;
  /**
   * Number of tool usage events in the bucket
   */
  eventCount: number;
  /**
   * Number of failed tool usage events in the bucket
   */
  failureCount: number;
  /**
   * Stable user identity value used by filters and chart grouping
   */
  userKey: string;
  /**
   * Tool usage user identity kind
   */
  userKind: ToolUsageUserTimeSeriesPointUserKind;
  /**
   * User-facing label for the user identity
   */
  userLabel: string;
};

/** @internal */
export const ToolUsageUserTimeSeriesPointUserKind$inboundSchema: z.ZodMiniEnum<
  typeof ToolUsageUserTimeSeriesPointUserKind
> = z.enum(ToolUsageUserTimeSeriesPointUserKind);

/** @internal */
export const ToolUsageUserTimeSeriesPoint$inboundSchema: z.ZodMiniType<
  ToolUsageUserTimeSeriesPoint,
  unknown
> = z.pipe(
  z.object({
    bucket_start_ns: z.string(),
    event_count: z.int(),
    failure_count: z.int(),
    user_key: z.string(),
    user_kind: ToolUsageUserTimeSeriesPointUserKind$inboundSchema,
    user_label: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "bucket_start_ns": "bucketStartNs",
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "user_key": "userKey",
      "user_kind": "userKind",
      "user_label": "userLabel",
    });
  }),
);

export function toolUsageUserTimeSeriesPointFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageUserTimeSeriesPoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageUserTimeSeriesPoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageUserTimeSeriesPoint' from JSON`,
  );
}
